import Announcements from "./Announcements";
export default function Header() {
  return (
    <>
      <header>
        <div className="header-wrapper">
          <Announcements />
          <span className="header-fixed-holder">
            <img
              className="clickable"
              onClick={(e) => {
                window.location.href = "https://mmods.es";
              }}
              src="https://mmods.es/cdn/img/logo.png"
            />
            <h3
              className="clickable"
              onClick={(e) => {
                window.location.href = "https://mmods.es";
              }}
            >
              Mmods GTA V
            </h3>
          </span>
        </div>
      </header>
    </>
  );
}
